import { useEffect, useState } from 'react';
import { getRecommendCase } from 'api/textVisit';
import { CaseListItem } from 'types/textVisit';

export default function useGetRecommendCase(): [CaseListItem | undefined, boolean, () => void] {
    const [loading, setLoading] = useState(false);
    const [recommendedCase, setRecommendedCase] = useState<CaseListItem>();

    const fetchData = async () => {
        try {
            setLoading(true);
            const result = await getRecommendCase();
            if (!result.error) {
                const data: CaseListItem = result?.data?.data;
                if (data) {
                    setRecommendedCase(data);
                } else {
                    setRecommendedCase(undefined);
                }
            }
            setLoading(false);
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchData();
    }, []);

    return [recommendedCase, loading, fetchData];
};
